module.exports = __webpack_public_path__ + "static/media/proctoring-ai.edacf5d0.gif";